<template>
	<span v-html="label"/>
</template>

<script>
import * as Label from "@/helper/characteristic/Label";
import {arrayIsNotEmpty} from "@/helper/Array";
import _ from "lodash";
import {maxLength} from "@/helper/String";

export default {

	props: {
		characteristic: {
			type: Object,
			required: true,
		},
		labelType: {
			type: String,
			required: false,
		},
		enclose: {
			type: Array,
			required: false,
		},
		supplements: {
			type: Array,
			required: false
		},
		highlightWords: {
			type: Array,
			required: false
		},
		maxItemLength: {
			type: Number,
			required: false
		}
	},

	computed: {
		label ()
		{
			let label = Label.get(this.characteristic, this.labelType);

			if (this.supplements && arrayIsNotEmpty(this.supplements))
			{
				let supplements = [];

				this.supplements.forEach(group =>
				{
					group.items.forEach(item =>
					{
						supplements.push(
							Label.get(item.item, this.labelType)
						);
					})
				});

				supplements.sort();

				label = label + ' (' + supplements.join(', ') + ')';
			}

			if (this.highlightWords)
			{
				const highlightWords = _.compact(this.highlightWords);

				highlightWords.forEach((item) =>
				{
					item = item.replace(/[|&;$%@"<>()+,]/g, '');

					label = label.replace(new RegExp(`(${item})`, 'ig'), '<span class="highlight">$1</span>');
				});
			}

			label = this.enclose
				? this.enclose[0] + label + this.enclose[1]
				: label;

			if (this.maxItemLength)
			{
				label = maxLength(label, this.maxItemLength);
			}

			return label;
		}
	},
}
</script>
